import { FormValidator, ValidationResult } from '../formField/types/form-validator';

export const MaxLengthValidator: (maxLength: number, errorMessage: string) => FormValidator = (
  maxLength: number,
  errorMessage: string
) => {
  return async (value: string): Promise<ValidationResult> => {
    if (value === undefined || value === null) {
      return { valid: true };
    }

    if (value.length > maxLength) {
      return {
        valid: false,
        error: errorMessage,
      };
    }

    return { valid: true };
  };
};
